export default __webpack_public_path__ + "static/media/15.f2c6bc62.svg";